import { Component } from 'react';
import {Control} from 'forms/rrf';
import {connect} from 'react-redux';
import {Col, Container, FormGroup, Row} from 'react-bootstrap';
import BsCheckbox from '../../../common/form/elements/bs-checkbox';

import Editor from './editor';

import './styles.css';

class SiteMessage extends Component {
  setSiteMessage = () => {
    this.setState({
      siteMessage: !this.state.siteMessage
    });
  };

  constructor(props) {
    super(props);
    this.state = {
      siteMessage: false,
    };
  }

  render() {
    return (
      <Container fluid className="editor">
        <Row>
          <Col md={12}>
            <FormGroup>
              <Control.checkbox
                component={BsCheckbox}
                model='.site_message'
                onChange={this.setSiteMessage}
              >
                Site Message
              </Control.checkbox>
            </FormGroup>

            {this.props.fetched && (
              <Editor
                content={this.props.siteBody}
                field="deep.admin_notification_edit.site_body"
              />
            )}

          </Col>
        </Row>
      </Container>

    );
  }
}

const mapStateToProps = state => ({
  siteBody: state.deep.admin_notification_edit.site_body,
  fetched: state.notifications.fetched,
  fetching: state.notifications.fetching,
});

export default connect(mapStateToProps)(SiteMessage);
